import { common } from '@tencent/ceiba-base-components';
const camelize = str => str.replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ''));

function getPluginName(ast, name) {
  return `$${name}${camelize(`-${ast}`)}Plugin`;
}

const astPlugin = {
  install(Vue) {
    Vue.prototype.$ast = {
      // entry_point

      entryPoint: async (meta) => {
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].entryPoint) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].entryPoint(meta);
        }
      },
      // share
      initShare: async (shareConfig) => {
        console.info('initShare shareConfig=', shareConfig);
        // APP环境
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')]
          && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].isAPP
          && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].isAPP()
          && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].initAPPShare) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].initAPPShare(shareConfig);
        } else {
          // 手动监听QQ分享，区分ark分享，和默认分享；
          // 非QQ渠道默认之前的TGmobileShare操作
          console.log('initShare common');
          const closeShareMask = () => {
            const maskDiv = document.getElementById('share-mask');
            if (!maskDiv) return;
            maskDiv.style.display = 'none';
          };
          let shareConfigLink = shareConfig.link || window.location.href;
          // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
          shareConfigLink = common.tool.passThroughUrlParam(shareConfigLink, ['via', 'trace_id', 'via_source']);

          // 判断是否登录 目前先从cookie中获取openid是否有值来进行登录判断
          const isLogin = common.tool.getCookie('openid');

          if (common.platform.isQQ && isLogin) {
            console.log('common.platform.isQQ');
            setTimeout(() => {
              window.mqq && window.mqq.ui.setOnShareHandler((type) => {
                console.log('setOnShareHandler share type=', type);
                // 0：QQ好友
                // 1：QQ空间
                // 2：微信好友
                // 3：微信朋友圈
                if (Number(type) === 0) {
                  // 均为必填项
                  const arkInfo = {
                    // 不设置或设置为空时，页面有title，则调取title
                    title: shareConfig.title || '',
                    // 不设置或设置为空时，页面有Description，则调取Description
                    desc: shareConfig.desc || '',
                    // 分享时的居右预览小图
                    preview: shareConfig.icon || '',
                    // 分享链接要跟当前页面同域名(手Q分享有这个要求) ,不设置或设置为空时，默认调取当前URL
                    jumpUrl: shareConfigLink,
                    // 点击流命名，用于统计分享量，专题一般采用目录名称如a20151029demo
                    // tag: `${Vue.prototype.$actInfo.ast}-${Vue.prototype.$actInfo.activity_id}`,
                    // 玩家收到的推送消息的提示
                    prompt: shareConfig.title || '腾讯游戏',
                    successCallback: () => {
                      closeShareMask();
                      console.log('【成功】分享给QQ好友！', arkInfo);
                    }, // 类型：function，成功回调函数
                    failCallback: (res) => {
                      closeShareMask();
                      console.log('分享失败：res=', res);
                    }, // 类型：function，失败回调函数
                  };
                  // 跨域同步登录态
                  Vue.prototype.$miloCore.loginStatus.syncToAME(() => {
                    // 设置 setShareInfo 也就是默认分享信息，微信、朋友圈等生效
                    Vue.prototype.$miloMobileShare.arkShare.init(arkInfo);
                    // 拉起qq的好友列表，直接分享
                    Vue.prototype.$miloMobileShare.arkShare.share(arkInfo);
                  });
                } else {
                  window.mqq.ui.shareMessage({
                    title: shareConfig.title || '',
                    desc: shareConfig.desc || '',
                    share_type: type,
                    share_url: shareConfigLink,
                    image_url: shareConfig.icon || '',
                    back: true, // 分享之后返回webview
                  });
                }
              });
            }, 200);
            return;
          }

          const shareWxAppid = Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')]?.currentAstConfig?.()?.SHARE_WX_APP_ID;
          console.log('initShare shareWxAppid = ', shareWxAppid);
          window.TGMobileShare({
            reportTcss: false,
            shareTitle: shareConfig.title, // 不设置或设置为空时，页面有title，则调取title
            shareDesc: shareConfig.desc, // 不设置或设置为空时，页面有Description，则调取Description
            shareImgUrl: shareConfig.icon, // 分享图片尺寸200*200，且填写绝对路径
            shareLink: shareConfigLink, // 分享链接要跟当前页面同域名(手Q分享有这个要求) ,不设置或设置为空时，默认调取当前URL
            actName: `ceiba_${Vue.prototype.$actInfo.activity_id}`, // 点击流命名，用于统计分享量，专题一般采用目录名称如a20151029demo
            wxAppId: shareWxAppid ? shareWxAppid : undefined, // 微信公众号appid， 微信分享QQ的时候会用到
          });
        }
      },
      setAPPShare: async (params) => {
        console.info('setAPPShare params=', params);
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].setAPPShare) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].setAPPShare(params);
        }
      },
      goAPPShare: async (params) => {
        console.info('goAPPShare');
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].goAPPShare) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].goAPPShare(params);
        }
      },
      disableAPPShare: async () => {
        console.info('disableAPPShare');
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].disableAPPShare) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].disableAPPShare();
        }
      },
      // app
      isAPP: () => {
        console.info('isAPP');
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].isAPP) {
          return Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].isAPP();
        }
        return true;
      },
      gotoAPP: async (link) => {
        console.info('gotoAPP');
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].gotoAPP) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].gotoAPP(link);
        }
      },
      openView: async (params) => {
        console.info('openView');
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].openView) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].openView(params);
        } else {
          window.location.href = params.url;
        }
      },
      doHook: async (name, options) => {
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].hooks && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].hooks[name]) {
          return await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].hooks[name](options);
        }
      },
      getFlowRequestExtData: async (params) => {
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].getFlowRequestExtData) {
          return await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].getFlowRequestExtData(params);
        }
        return {};
      },
      makeAPPShareCallBack: () => {
        console.info('access makeAPPShareCallBack');
        const actName = getPluginName(Vue.prototype.$actInfo.ast, 'ast');
        if (Vue.prototype[actName] && Vue.prototype[actName].makeAPPShareCallBack) {
          // 返回各自业务的分享回调处理函数
          console.info('access makeAPPShareCallBack and business handle function');
          return Vue.prototype[actName].makeAPPShareCallBack();
        }
        return null;
      },
      currentAstConfig: () => {
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].currentAstConfig) {
          return Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].currentAstConfig();
        }
        return {};
      },
      currentAstName: () => {
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].currentAstName) {
          return Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].currentAstName();
        }
        return '';
      },
      getShareUrl: (params) => {
        console.info('getShareUrl params=', params);
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].getShareUrl) {
          return Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'ast')].getShareUrl(params);
        }
        return '';
      },
    };
  },
};

export default astPlugin;
